module.exports = __webpack_public_path__ + "img/zz.308740f5.png";